import { gql } from '@/__generated__/storefront';

export const customerLoyaltyPointsQuery = gql(`
  query LoyaltyPoints($customerAccessToken: String!) {
    customer(customerAccessToken: $customerAccessToken) {
      loyaltyPoints: metafield(key: "loyalty_points", namespace: "hobbii") {
        value
      }
    }
  }
`);

export const variantLoyaltyPointsQuery = gql(`
  query variantPointsCost($id: ID!) {
    node(id: $id) {
    ... on ProductVariant {
      id
      metafield(key: "loyalty_points_cost", namespace: "hobbii") {
        value
      }
    }
  }
}`);
